<template>
    <div class="bjex-main" v-loading="loading">
        <div>
            <el-tabs v-model="activeName">
                <el-tab-pane label="整本书" name="book"></el-tab-pane>
                <el-tab-pane label="系列阅读" name="package"></el-tab-pane>
            </el-tabs>
        </div>
        <div>
            <el-form label-width="80px" v-if="activeName == 'book'">

                <el-form-item label="适合年级:">
                    <el-button type="text" @click="; (gradeId = ''), queryBookList()"
                        :class="gradeId == '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (gradeId = item.id), queryBookList()"
                        :class="item.id == gradeId ? '' : 'yanse'" v-for="item in gradelist" :key="item.id">{{ item.name
                        }}</el-button>
                </el-form-item>
                <el-form-item label="所属专栏:">
                    <el-button type="text" @click="; (specialId = ''), queryBookList()"
                        :class="specialId == '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (specialId = item.code), queryBookList()"
                        :class="item.code == specialId ? '' : 'yanse'" v-for="item in specialColumn" :key="item.code">{{
                            item.name
                        }}</el-button>
                </el-form-item>
            </el-form>
            <el-form label-width="80px" v-if="activeName == 'package'">
                <el-form-item label="适合年级:">
                    <el-button type="text" @click="; (gradeId = ''), queryBillList()"
                        :class="gradeId == '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (gradeId = item.id), queryBillList()"
                        :class="item.id == gradeId ? '' : 'yanse'" v-for="item in gradelist" :key="item.id">{{ item.name
                        }}</el-button>
                </el-form-item>
                <el-form-item label="所属专栏:">
                    <el-button type="text" @click="; (specialId = ''), queryBillList()"
                        :class="specialId == '' ? '' : 'yanse'">全部</el-button>
                    <el-button type="text" @click="; (specialId = item.code), queryBillList()"
                        :class="item.code == specialId ? '' : 'yanse'" v-for="item in specialColumn" :key="item.code">{{
                            item.name
                        }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div v-if="activeName == 'book'">
            <div style="display: flex; justify-content: space-between; align-items: center">
                <div>
                    <el-select v-model="classifyId" placeholder="请选择图书所属分类" clearable size="small" style="width: 150px"
                        @change="(curPage = 1), queryBookList()">
                        <el-option v-for="item in options" :key="item.id" :label="item.classifyName" :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- <el-cascader style="width: 130px" clearable v-model="classifyId" @change=";(curPage = 1),queryBookList" placeholder="请选择图书所属分类" :options="options" :show-all-levels="false" size="small"></el-cascader> -->
                    <el-select v-model="bookLevel" placeholder="请选择图书等级" clearable size="small" style="width: 150px"
                        @change="(curPage = 1), queryBookList()">
                        <el-option v-for="item in bookLevelList" :key="item.id" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                    <el-select v-model="hasResList" placeholder="是否有资源" clearable size="small" style="width: 150px"
                        @change="(curPage = 1), queryBookList()">
                        <el-option label="是" :value="1"> </el-option>
                        <el-option label="否" :value="0"> </el-option>
                    </el-select>
                    <el-select v-model="hasTest" placeholder="是否有测评" clearable size="small" style="width: 150px"
                        @change="(curPage = 1), queryBookList()">
                        <el-option label="是" :value="1"> </el-option>
                        <el-option label="否" :value="0"> </el-option>
                    </el-select>
                    <el-select v-model="hasHomeWork" placeholder="是否有作业" clearable size="small" style="width: 150px"
                        @change="(curPage = 1), queryBookList()">
                        <el-option label="是" :value="1"> </el-option>
                        <el-option label="否" :value="0"> </el-option>
                    </el-select>
                    <el-select v-model="bookHot" placeholder="热度" clearable size="small" style="width: 150px"
                        @change="(curPage = 1), queryBookList()">
                        <el-option label="从高到低" :value="1"> </el-option>
                        <el-option label="从低到高" :value="0"> </el-option>
                    </el-select>
                    <el-input v-model="bookName" clearable placeholder="请输入图书名称关键词" size="small"
                        style="width: 200px"></el-input>
                    <!-- <el-input v-model="bookCode" clearable placeholder="请输入图书编号" size="small" style="width: 200px"></el-input> -->
                    <el-button type="primary" size="small" @click="(curPage = 1), queryBookList()">搜索</el-button>
                </div>
                <div class="bhui">
                    <el-button type="primary" size="small" @click="changes(1)">批量加入校本</el-button>
                </div>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" highlight-current-row ref="multipleTable"
                @selection-change="handleSelectionChanges">
                <el-table-column type="selection" align="center" />
                <el-table-column label="封面" align="center" width="130">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 120px"
                            :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''" fit="cover">
                            <div slot="error" class="image-err">暂无封面</div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
                <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
                <el-table-column prop="specialColumnName" label="所属专栏" align="center"></el-table-column>
                <!-- <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"></el-table-column> -->
                <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
                <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
                <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
                <el-table-column prop="bookCode" label="配套资源" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.reslistCount }}
                        <!-- <el-button type="text"
                            @click="multipleSelections = [scope.row], changes(1)">{{ scope.row.reslistCount }}</el-button> -->
                    </template>
                </el-table-column>
                <el-table-column prop="testCount" label="相关评测" align="center"></el-table-column>
                <el-table-column prop="homeworkCount" label="相关作业" align="center"></el-table-column>

                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" @click="detailBook(scope.row)">详情</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: right; padding: 10px" @prev-click="change" @next-click="change"
                :page-size="10" @current-change="change" background layout="total,prev, pager, next"
                :hide-on-single-page="true" :total="totalCount"></el-pagination>
        </div>
        <div v-if="activeName == 'package'">
            <div style="display: flex; justify-content: space-between; align-items: center">
                <div>
                    <el-input v-model="bookName" clearable placeholder="请输入系列名称关键词" size="small"
                        style="width: 200px"></el-input>
                    <el-button type="primary" size="small" @click="; (curPage = 1), queryBillList()">搜索</el-button>
                </div>
                <!-- <div class="bhui">
                    <el-button type="primary" size="small" @click="changes(1)">批量加入校本</el-button>
                </div> -->
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" highlight-current-row ref="package">
                <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
                <el-table-column label="封面" align="center" width="130">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 120px"
                            :src="scope.row.imgUrl ? scope.row.serverHttp + scope.row.imgUrl : ''" fit="cover">
                            <div slot="error" class="image-err">暂无封面</div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="billName" label="名称" align="center"></el-table-column>
                <el-table-column prop="billGradesName" label="适合年级" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.publishStatus == 1 ? (scope.row.delistStatus == 1 ? '已上架' : '未上架') : '未发布' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" @click="detailBill(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: right; padding: 10px" @prev-click="change2" @next-click="change2"
                :page-size="10" @current-change="change2" background layout="total,prev, pager, next"
                :hide-on-single-page="true" :total="totalCount"></el-pagination>
        </div>
        <el-dialog :title="activeName == 'book' ? '图书详情' : '书单详情'" :visible.sync="dialogVisible" width="60vw">
            <el-descriptions :column="1">
                <el-descriptions-item label="名称">{{ activeName == 'book' ? seeItem.bookName : seeItem.billName
                    }}</el-descriptions-item>
                <el-descriptions-item label="封面"><img style="width: 200px; height: 240px"
                        :src="activeName == 'book' ? seeItem.serverHttp + seeItem.bookImgUrl : seeItem.serverHttp + seeItem.imgUrl" /></el-descriptions-item>
                <el-descriptions-item label="适合年级">{{ activeName == 'book' ? seeItem.bookGradesName :
                    seeItem.billGradesName
                    }}</el-descriptions-item>
                <el-descriptions-item label="图书分类"
                    v-if="activeName == 'book' && seeItem.readClassifyBookList.length > 0">{{
                        seeItem.readClassifyBookList[0].classifyName }}</el-descriptions-item>
                <el-descriptions-item label="所属专栏">{{ getNameById(seeItem.specialColumn, specialColumn, 'code', 'name')
                    }}</el-descriptions-item>
                <el-descriptions-item label="阅读分级(星星值)" v-if="activeName == 'book'">
                    <span style="margin-right: 5px">开始阅读星星值 {{ seeItem.starRuleObj.startReadNumber }}颗</span>
                    <span style="margin-right: 5px">结束阅读星星值 {{ seeItem.starRuleObj.endReadNumber }}颗</span>
                    <span style="margin-right: 5px">提交读后感星星值 {{ seeItem.starRuleObj.summitFeelNumber }}颗</span>
                    <span style="margin-right: 5px">完成测评星星值 {{ seeItem.starRuleObj.complatePaperNumber }}颗</span>
                </el-descriptions-item>
                <el-descriptions-item label="作者" v-if="activeName == 'book'">{{ seeItem.bookAuthor
                    }}</el-descriptions-item>
                <el-descriptions-item label="出版社" v-if="activeName == 'book'">{{ seeItem.publishingName
                    }}</el-descriptions-item>
                <el-descriptions-item label="编号" v-if="activeName == 'book'">{{ seeItem.bookCode
                    }}</el-descriptions-item>
                <el-descriptions-item label="图书字数" v-if="activeName == 'book'">{{ seeItem.wordNumber
                    }}</el-descriptions-item>
                <el-descriptions-item label="简介">
                    <div class="richText" v-html="activeName == 'book' ? seeItem.bookIntro : seeItem.billIntro"></div>
                </el-descriptions-item>
                <el-descriptions-item label="系列图书" v-if="activeName == 'package'">
                    <el-table :data="seeItem.readBooksList" border stripe highlight-current-row ref="table"
                        :header-cell-style="{ height: '40px', padding: 0 }">
                        <el-table-column label="序号" align="center" type="index" width="55"> </el-table-column>
                        <el-table-column label="封面" align="center" width="130">
                            <template slot-scope="scope">
                                <el-image style="width: 100px; height: 100px"
                                    :src="scope.row.bookImgUrl ? scope.row.serverHttp + scope.row.bookImgUrl : ''"
                                    fit="cover">
                                    <div slot="error" class="image-err">暂无封面</div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bookName" label="名称" align="center"></el-table-column>
                        <el-table-column prop="bookGradesName" label="适合年级" align="center"></el-table-column>
                        <el-table-column prop="bookStarNumber" label="阅读分级（星星值）" align="center"
                            width="85"></el-table-column>
                        <el-table-column prop="bookAuthor" label="作者" align="center"> </el-table-column>
                        <el-table-column prop="publishingName" label="出版社" align="center"></el-table-column>
                        <el-table-column prop="bookCode" label="编号" align="center"></el-table-column>
                    </el-table>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { ERR_OK, BASE_URL } from '@/api/index'
export default {
    data() {
        return {
            headers: {
                token: '' //文件上传请求头
            },
            fileList: [],
            dats: {},
            activeName: 'book',
            loading: false,
            courselist: [],
            totalCount: 0,
            bookName: '',
            bookCode: '',
            specialColumn: [],
            specialId: '',
            gradelist: [],
            gradeId: '',
            tableData: [],
            publishStatus: 1,
            classifyId: [],
            seeItem: {
                starRuleObj: {},
                readClassifyBookList: []
            },
            dialogVisible: false,
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            dialogVisible4: false,
            bookLevelList: [],
            bookLevel: '',
            options: [], //图书分类
            dialogVisible6: false,
            resource_typelist: [],
            resource_originlist: [],
            resource_steplist: [],
            curPages: 1,
            pageSize: 10,
            resTypeId: '',
            resSourceId: '',
            resStep: '',
            userType: -1,
            resLimit: '',
            bookRelation: '',
            resTitle: '',
            TableList: [],
            totalCounts: 0,
            multipleSelection: [],
            multipleSelections: [],
            bookHot: '',
            hasResList: '',
            hasTest: '',
            hasHomeWork: '',
            curPage: 1
        }
    },
    activated() {
        switch (this.activeName) {
            case 'book':
                this.queryBookList()
                break
            case 'package':
                this.queryBillList()
                break
            default:
                break
        }
    },
    created() {
        this.headers.token = localStorage.getItem('token')
        this.dictcode()
        this.dictcode1()
        this.dictcodes()
        this.dictcodes1()
        this.dictcodes2()
        this.getGradeStage()
        this.getTreeReadClassify()
        if (localStorage.getItem('read_index')) {
            this.activeName = localStorage.getItem('read_index')
            localStorage.removeItem('read_index')
        }
        switch (this.activeName) {
            case 'book':
                this.queryBookList()
                break
            case 'package':
                this.queryBillList()
                break
            default:
                break
        }
    },
    watch: {
        bookLevel(v) {
            this.queryBookList()
        },
        activeName(v) {
            this.bookName = ''
            this.bookCode = ''
            this.specialId = ''
            this.gradeId = ''
            this.publishStatus = 1
            this.classifyId = []
            this.curPage = 1
            switch (v) {
                case 'book':
                    this.queryBookList()
                    break
                case 'package':
                    this.queryBillList()
                    break
                default:
                    break
            }
        }
    },
    methods: {
        detailBill(s) {
            this.$router.push({
                path: '/readBill',
                query: {
                    id: s.id,
                    modeType: 'detail'
                }
            })
        },
        detailBook(s) {
            this.$router.push({
                path: '/readBook',
                query: {
                    id: s.id,
                    modeType: 'detail'
                }
            })
        },
        dictcodes() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_type'
                })
                .then((res) => {
                    that.resource_typelist = res.data.data
                })
        },
        dictcodes1() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_origin'
                })
                .then((res) => {
                    that.resource_originlist = res.data.data
                })
        },
        dictcodes2() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_step'
                })
                .then((res) => {
                    that.resource_steplist = res.data.data
                })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
            console.log(val)
        },
        handleSelectionChanges(val) {
            this.multipleSelections = val
        },
        changes(s) {
            let that=this
            if (this.multipleSelections.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择书籍!'
                })
                return
            }
            this.$alert('是否确定将所选书籍加入校本？', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                    that.ques()
                }
                });
        },
        resourcequeryList() {
            let that = this
            homeApi
                .resourcequeryList({
                    curPage: this.curPages,
                    pageSize: 10,
                    resTypeId: this.resTypeId,
                    resSourceId: this.resSourceId,
                    resStep: this.resStep,
                    userType: this.userType == -1 ? '' : this.userType,
                    resLimit: this.resLimit,
                    bookRelation: this.bookRelation,
                    resTitle: this.resTitle
                })
                .then((res) => {
                    this.TableList = res.data.data.dataList
                    this.totalCounts = res.data.data.totalCount
                })
        },
        ques() {
            let that = this
                let bookIds = []
                for (var i = 0; i < this.multipleSelections.length; i++) {
                    bookIds.push(this.multipleSelections[i].id)
                }
                // return false
                let params = {
                    bookIds: bookIds.toString(),
                }
                homeApi
                    .batchAddToSchoolBooks(params)
                    .then((res) => {
                        this.multipleSelections = []
                        this.multipleSelection = []
                        this.queryBookList()
                    })
                    .catch(() => { })
        },
        onExceed() {
            this.$message.error('一次只能上传一个文件!')
        },
        exportReadBookTemplate() {
            homeApi.exportReadBookTemplate()
        },
        clearDats(done) {
            this.dats = {}
            done()
        },
        importClose(done) {
            this.fileList = []
            done()
        },
        shangchausjffas() {
            this.loading = true
        },
        handleRemove(file, fileList) { },
        handlePreview(file) { },
        submitUpload() {
            this.$refs.upload.submit()
        },
        submitUpload2() {
            this.$refs.upload2.submit()
        },
        urlsyrl() {
            return BASE_URL + '/read/import/importBooK'
        },
        urlsyrl2() {
            return BASE_URL + '/read/import/importQuestion'
        },
        chengg(data) {
            this.loading = false
            this.dialogVisible1 = false
            this.dialogVisible4 = false
            this.fileList = []
            this.queryBookList()
            if (data.code == 0) {
                this.dats = data.data
                this.dialogVisible3 = true
                this.$message({
                    message: '上传成功',
                    type: 'success'
                })
            } else {
                this.$message({
                    message: '上传失败',
                    type: 'success'
                })
                this.$message(data.msg)
            }
        },
        chengg1() {
            this.loading = false
            this.$message('上传失败')
        },
        modifyBillPublishStatus(item) {
            if (item.publishStatus == 0) {
                let params = {
                    publishStatus: 1,
                    id: item.id
                }
                homeApi
                    .modifyBillPublishStatus(params)
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message.success('操作成功')
                            this.queryBillList()
                        }
                    })
                    .catch(() => { })
            } else {
                let params = {
                    delistStatus: item.delistStatus == 0 ? 1 : 0,
                    id: item.id
                }
                homeApi
                    .modifyBillDelistStatus(params)
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message.success('操作成功')
                            this.queryBillList()
                        }
                    })
                    .catch(() => { })
            }
        },
        toPublish(item) {
            let params = {
                bookId: item.id
            }
            homeApi
                .getResourceByBookId(params)
                .then((res) => {
                    if (res.data.code == 0) {
                        if (res.data.data.length == 0 || !item.paperRule) {
                            this.$confirm('该书没有配套资源或测评设置，确认发布吗？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            })
                                .then(() => {
                                    let params = {
                                        publishStatus: 1,
                                        id: item.id
                                    }
                                    homeApi
                                        .modifyPublishStatus(params)
                                        .then((res) => {
                                            if (res.data.code == 0) {
                                                this.$message.success('发布成功')
                                                this.queryBookList()
                                            }
                                        })
                                        .catch(() => { })
                                })
                                .catch(() => { })
                        } else {
                            this.$confirm('发布后无法撤回，确认发布吗？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            })
                                .then(() => {
                                    let params = {
                                        publishStatus: 1,
                                        id: item.id
                                    }
                                    homeApi
                                        .modifyPublishStatus(params)
                                        .then((res) => {
                                            if (res.data.code == 0) {
                                                this.$message.success('发布成功')
                                                this.queryBookList()
                                            }
                                        })
                                        .catch(() => { })
                                })
                                .catch(() => { })
                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        modifyPublishStatus(item) {
            if (item.publishStatus == 0) {
                let params = {
                    publishStatus: 1,
                    id: item.id
                }
                homeApi
                    .modifyPublishStatus(params)
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message.success('操作成功')
                            this.queryBookList()
                        }
                    })
                    .catch(() => { })
            } else {
                let params = {
                    delistStatus: item.delistStatus == 0 ? 1 : 0,
                    id: item.id
                }
                homeApi
                    .modifyDelistStatus(params)
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.$message.success('操作成功')
                            this.queryBookList()
                        }
                    })
                    .catch(() => { })
            }
        },
        getTreeReadClassify() {
            let that = this
            let params = {
                schoolId: -1
            }
            homeApi
                .getTreeReadClassify(params)
                .then((res) => {
                    res.data.data = that.xunahj(res.data.data)
                    that.options = res.data.data
                })
                .catch(() => { })
        },
        xunahj(s) {
            s.forEach((item) => {
                item.value = item.id
                item.label = item.classifyName
                if (item.chilrenList && item.chilrenList.length > 0) {
                    item.children = item.chilrenList
                    this.xunahj(item.children)
                }
            })
            return s
        },
        //年级列表
        getGradeStage() {
            let that = this
            homeApi
                .getGradeStage({
                    stage: 5
                })
                .then((res) => {
                    that.gradelist = res.data.data
                })
        },
        getNameById(id, targetList, idName, name) {
            let result = '暂无'
            let index = targetList.findIndex((i) => {
                return i[idName] == id
            })
            if (index != -1) {
                result = targetList[index][name]
            }
            return result
        },
        dictcode1() {
            let that = this
            homeApi
                .dictcode({
                    code: 'book_level'
                })
                .then((res) => {
                    that.bookLevelList = res.data.data
                })
        },
        dictcode() {
            let that = this
            homeApi
                .dictcode({
                    code: 'special_column'
                })
                .then((res) => {
                    that.specialColumn = res.data.data
                })
        },
        delBill(s) {
            this.$confirm('是否删除此书单，删除后无法恢复！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let that = this
                    let params = {
                        id: s.id
                    }
                    homeApi
                        .delBill(params)
                        .then((res) => {
                            that.$message({
                                type: 'success',
                                message: '操作成功!'
                            })
                            that.queryBillist()
                        })
                        .catch(() => { })
                })
                .catch(() => { })
        },
        delBook(s) {
            this.$confirm('是否删除此书籍，删除后无法恢复！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let that = this
                    let params = {
                        id: s.id
                    }
                    homeApi
                        .delBook(params)
                        .then((res) => {
                            that.$message({
                                type: 'success',
                                message: '操作成功!'
                            })
                            that.queryBookList()
                        })
                        .catch(() => { })
                })
                .catch(() => { })
        },
        change(s) {
            this.curPage = s
            this.queryBookList()
        },
        change2(s) {
            this.curPage = s
            this.queryBillList()
        },
        queryBillList() {
            let that = this
            this.loading = true
            // console.log(this.leafClassifyId)
            let params = {
                schoolId: -1,
                pageNum: this.curPage,
                pageSize: 10,
                billName: this.bookName,
                publishStatus: this.publishStatus.toString(),
                bookGrades: this.gradeId.toString(),
                specialColumn: this.specialId.toString()
            }
            homeApi
                .queryBillList(params)
                .then((res) => {
                    that.tableData = res.data.data.dataList
                    that.totalCount = res.data.data.totalCount
                    that.loading = false
                })
                .catch(() => {
                    that.loading = false
                })
        },
        queryBookList() {
            let that = this
            this.loading = true
            // console.log(this.leafClassifyId)
            let params = {
                schoolId: -1,
                pageNum: this.curPage,
                curPage: this.curPage,
                pageSize: 10,
                bookCode: this.bookCode,
                bookName: this.bookName,
                bookLevel: this.bookLevel,
                publishStatus: this.publishStatus.toString(),
                classifyId: this.classifyId.length > 0 ? this.classifyId[this.classifyId.length - 1].toString() : '',
                bookGrades: this.gradeId.toString(),
                specialColumn: this.specialId.toString(),
                hasResList: this.hasResList,
                hasTest: this.hasTest,
                hasHomeWork: this.hasHomeWork,
                bookHot: this.bookHot,
            }
            homeApi
                .queryList(params)
                .then((res) => {
                    that.tableData = res.data.data.dataList
                    that.totalCount = res.data.data.totalCount
                    that.loading = false
                })
                .catch(() => {
                    that.loading = false
                })
        },
        dictcode2() {
            let that = this
            homeApi
                .dictcode({
                    code: 'course_limit'
                })
                .then((res) => {
                    that.courselist = res.data.data
                })
        }
    }
}
</script>
<style lang="less" scoped>
.yanse {
    color: #999;
}

.bhui {
    // background-color: #eee;
    padding: 10px;
    margin: 10px 0;
}

.nhufa {
    padding-top: 15px;
}

.el-radio {
    margin-bottom: 15px;
}

.ifra {
    min-height: 800px;
}

.el-tag {
    margin-right: 10px;
}

.magf {
    margin: 15px 0;
}

.courseNames::after {
    content: ',';
}

.courseNames:last-child::after {
    content: '';
}

.pcourseNames::after {
    content: ',';
}

.pcourseNames:last-child::after {
    content: '';
}

.el-radio {
    margin-bottom: 0px;
}

/deep/.image-err {
    height: 100px;
    line-height: 100px;
}

.el-form-item {
    margin-bottom: 0px;
}

.xuanhjifas {
    padding: 10px 20px;
    cursor: pointer;
}

.xuanhjifas:hover {
    border-color: #b3d8ff;
    color: #006eff;
    background: #ecf5ff;
}

.xuanhjjssss {
    border-color: #b3d8ff;
    color: #fff;
    background: #006eff;
}

.richText /deep/ img {
    max-width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/platform/platform.vue